export const eInvoiceActivationEndpoints = {
    getStatus: 'edocuments/registration/cvr',
    activate: 'edocuments/registration/cvr',
    deactivate: 'edocuments/registration/cvr',
    getCurrentCompany: '/company/GetCurrentCompany',
    updateCurrentCompany: '/company/UpdateCurrentCompany',
};
